import React from 'react';
import filterProps from './filter-props';

/**
 * The basic building block of the web: a simple block
 * of UI.
 *
 * @param {object} props props
 * @returns {HTMLElement} The block
 */
export default function Block(props) {
  return <div { ...filterProps('div', props) } />;
}



// WEBPACK FOOTER //
// ./node_modules/@ux/containers/block.js